const BICYCLE_SCAN_HISTORY = {
  columns: [
    {
      label: 'bicycle_scan_history.system_name_header',
      field: 'system.name',
      ordering: false,
      getValue(raw) {
        return raw.system ? raw.system.name : '';
      }
    },
    {
      label: 'bicycle_scan_history.location_name_header',
      field: 'location.name',
      ordering: false,
      getValue(raw) {
        return raw.location ? raw.location.label : '';
      }
    },
    {
      label: 'bicycle_scan_history.user_header',
      field: 'user.firstName,user.lastName',
      ordering: false,
      getValue(raw) {
        return raw.user ? (raw.user.firstName + ' ' + raw.user.lastName) : '';
      }
    },
    {
      label: 'bicycle_scan_history.scan_date_header',
      field: 'scanDate',
      ordering: true,
      getValue(raw) {
        return raw.scanDate ? raw.scanDate : '-'
      }
    }
  ]
}

export default BICYCLE_SCAN_HISTORY;
